<template>
  <ul class="m-the-alerts">
    <transition-group name="a-alert-primary-fade">
      <AtomAlertPrimary
        v-for="(alert, index) in $alerts.alerts"
        :key="`alert-${index}`"
        :alert="alert"
        :index="index"
      />
    </transition-group>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeTheAlerts'
}
</script>
